import { Box, SvgIcon } from '@mui/material';
import PlayRoundedIcon from 'assets/icons/play-rounded.svg';
import AlertCircleIcon from 'mdi-react/AlertCircleIcon';
import { bool, func } from 'prop-types';
import React from 'react';

const PlayButton = ({ loaded }) => {
  if (!loaded) {
    return (
      <Box
        sx={{
          width: 37,
          height: 37,
          marginRight: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box component="span" sx={{ color: 'error.main', display: 'flex' }}>
          <AlertCircleIcon />
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: 32,
        height: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: 0.9,
        color: 'common.white',
        filter: 'drop-shadow(0 0 12px rgba(0, 0, 0, 0.7))',
      }}
    >
      <SvgIcon sx={{ fontSize: 40, color: 'inherit', '& path': { fill: 'currentColor' } }}>
        <PlayRoundedIcon />
      </SvgIcon>
    </Box>
  );
};

PlayButton.propTypes = {
  loaded: bool.isRequired,
  onClick: func.isRequired,
};

export default PlayButton;
